module.exports = __webpack_public_path__ + "img/trash-bin-outline.b3ab344b.gif";